import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_footwear: FaireCategoryEntity = {
  token: "cat_footwear",
  type: "category",
  name: "Footwear",
  level: 1,
  href: "/category/footwear",
  childCategoryTokens: [
    "cat_footwear-all",
    "cat_footwear-new-products",
    "cat_footwear-new-brands",
    "cat_footwear-bestsellers",
    "cat_footwear-women",
    "cat_footwear-men",
  ],
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
